import React, { useContext } from 'react';
import axios from 'axios';
import { Form } from 'react-final-form';
import { Column, Button, Text, Flex } from '../../design-system';
import { Session, ACTIONS } from '../../contexts/sessionContext';
import Alert from '../../helpers/alert';
import FieldColumn from '../../components/FieldColumn';
import { required } from '../../helpers/utils';
import GrantholsterBrand, {
  MainContainer,
  FormContainer,
  StyledBlockLink,
} from '../../components/GrantholsterBrand';

const Login = () => {
  const { dispatch } = useContext(Session);
  const onSubmit = async (values: Record<string, string>) => {
    try {
      const { data } = await axios.post('/auth/login', values);
      dispatch({ type: ACTIONS.SET_USER, value: data.user });
    } catch (error) {
      Alert.error('Incorrect email and password combination');
    }
  };

  return (
    <MainContainer fluid>
      <Flex height="100%">
        <Column
          flexDirection="column"
          width="50%"
          justifyContent="center"
          alignItems="center"
        >
          <Text mb={20} fontSize={20}>
            Login
          </Text>
          <FormContainer>
            <Form
              onSubmit={onSubmit}
              render={({ handleSubmit, submitting, pristine }) => (
                <form onSubmit={handleSubmit}>
                  <FieldColumn
                    name="email"
                    label="Email"
                    placeholder="Email"
                    validate={required}
                  />
                  <FieldColumn
                    name="password"
                    label="Password"
                    type="password"
                    placeholder="Password"
                    validate={required}
                  />
                  <Column mt={1} flexDirection="column">
                    <Button
                      id="sign-in-button"
                      type="submit"
                      loading={submitting}
                    >
                      Sign In
                    </Button>
                  </Column>
                  <Flex justifyContent="space-between">
                    <StyledBlockLink to="/forgot-password">
                      Forgot Password?
                    </StyledBlockLink>
                    <StyledBlockLink to="/register">Sign Up</StyledBlockLink>
                  </Flex>
                </form>
              )}
            />
          </FormContainer>
        </Column>
        <GrantholsterBrand />
      </Flex>
    </MainContainer>
  );
};

export default Login;
